import { render, staticRenderFns } from "./Clamp.vue?vue&type=template&id=25b5b984&"
import script from "./Clamp.vue?vue&type=script&setup=true&lang=js&"
export * from "./Clamp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports